module.exports = __webpack_public_path__ + "static/media/file.d1786b97.svg";